import React, { memo } from 'react'
import { css } from 'styled-components/macro'
import { Box } from '@alobato/flex-box'
import Text from '@alobato/text'
import { Table, TableContainer, TableRow, TableCell, TableHeaderRow, TableHeaderCell } from '../../components/DataTable'
import { EmptyState } from '../../components/ui'
import MenuOver from '../../components/MenuOver'
import { MoreIcon } from '../../components/Icons'
import Pagination from '../../components/Pagination'

const orDash = value => (value === null || value === undefined || value === '' ? '—' : value)

/* "CRM 123456 / SP · CRM 654321 / RJ".
   A API manda `crms` pronto; o fallback cobre resposta antiga em cache. */
const formatarCRMs = item => {
  if (Array.isArray(item.crms) && item.crms.length) {
    return item.crms.map(c => `${c.type} ${c.number}${c.uf ? ` / ${c.uf}` : ''}`).join(' · ')
  }
  return [
    item.crm && `CRM ${item.crm}${item.crm_uf ? ` / ${item.crm_uf}` : ''}`,
    item.crm_secondary && `CRM ${item.crm_secondary}${item.crm_secondary_uf ? ` / ${item.crm_secondary_uf}` : ''}`
  ].filter(Boolean).join(' · ')
}

const List = ({ items, navigate, deleteItem, onPageChange, currentPage, pageCount }) => {

  const handleMenuOverClick = (action, id) => {
    switch (action) {
      case 'delete':
        deleteItem(id)
        break
      case 'show':
        navigate(`${id}`)
        break
      case 'edit':
        navigate(`${id}/editar`)
        break
      default:
        return false
    }
  }

  return (
    <>
      <Box mb={5}>
        {!!items.length ? (
          <TableContainer>
            <Table>
              <TableHeaderRow>
                <TableHeaderCell>Nome</TableHeaderCell>
                <TableHeaderCell>CRM</TableHeaderCell>
                <TableHeaderCell>Email</TableHeaderCell>
                <TableHeaderCell></TableHeaderCell>
              </TableHeaderRow>
              {items.map(item => (
                <TableRow key={item.id}>
                  <TableCell data-title='Nome'>{orDash(item.name)}</TableCell>
                  <TableCell data-title='CRM'>{orDash(formatarCRMs(item))}</TableCell>
                  <TableCell data-title='Email'>{orDash(item.login)}</TableCell>
                  <TableCell width={40} lineHeight={0}>
                    <MenuOver
                      options={[{label: 'Detalhes', value: 'show'}, {label: 'Editar', value: 'edit'}, {label: 'Excluir', value: 'delete'}]}
                      onSelect={action => handleMenuOverClick(action, item.id)}
                    >
                      <MoreIcon style={{cursor: 'pointer'}} />
                    </MenuOver>
                  </TableCell>
                </TableRow>
              ))}
            </Table>
          </TableContainer>
        ) : (
          <EmptyState />
        )}
      </Box>

      <Box ta='center'>
        <Pagination onPageChange={onPageChange} currentPage={currentPage} pageCount={pageCount} />
      </Box>
    </>
  )
}

export default memo(List)
